import React, { useState } from "react";
import BottomSheetMf from "../../bottomSheetMF/bottomSheetMf";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, FetchPortfolioModalType, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Image, View } from "react-native";
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import { addCommasToNumber } from "../../stack/utils";
const SDKProcessCompleteCard = ({ visible = false, type = FetchPortfolioModalType.IMMEDIATE, onModalClose, onModalCloseAction, triggerAction, onWithdrawClickAction, isCreditStatusActive, availableCreditLimit }) => {
    const [_show, setShowModal] = useState(visible);
    return (React.createElement(BottomSheetMf, { modalVisible: visible, isFromSDKProcessingCard: true, onModalClose: () => {
            setShowModal(false);
            triggerAction({
                ...onModalCloseAction
            });
        }, onModalOpen: () => setShowModal(true), showClose: type !== FetchPortfolioModalType.LOADER, onClosePress: () => {
            onModalCloseAction &&
                triggerAction({
                    ...onModalCloseAction
                });
        } },
        React.createElement(View, { style: { alignContent: 'center', alignItems: 'center' } },
            React.createElement(Image, { style: { width: 300, height: 191 }, source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/sdk_process_complete.png" } }),
            React.createElement(View, { style: { marginTop: 32, marginBottom: 4 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: "Congratulations!", color: ColorTokens.Grey_Night })),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: `You can now access up to ₹${addCommasToNumber(Number(availableCreditLimit))}. Tap to withdraw your funds`, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center }),
            React.createElement(View, { style: { marginTop: 24, width: '100%' } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Withdraw", sizeDLS: ButtonSizeDLS.MEDIUM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...onWithdrawClickAction
                        });
                    } })))));
};
export default SDKProcessCompleteCard;
